export const formatBuildTime = (value = process.env.REACT_APP_BUILD_TIME): string => {
  if (!value) return "unknown";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "shortOffset",
  }).format(date);
};

// Release branches carry the shipped version in their name (release/2.4.1); anything
// else is a work branch, which reports the placeholder instead of a branch name.
export const getAppVersionLabel = (version = process.env.REACT_APP_GIT_BRANCH): string => {
  const versionValue = version?.trim();
  const releasePrefix = "release/";

  if (!versionValue) return "";

  const isReleaseVersion = versionValue.toLowerCase().startsWith(releasePrefix);

  return isReleaseVersion ? versionValue.slice(releasePrefix.length) : "v1.0.0.0";
};
